import React from 'react';
import { SimpleForm, TextInput, required, regex } from 'react-admin';
import { CreateDialog } from '@react-admin/ra-form-layout';
import RichTextInput from 'ra-input-rich-text';
import CustomLabelInput from '../components/CustomLabelInput';

function phoneNumberFormat(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    } else if (phoneNumberString.length >= 14) {
        return phoneNumberString.substring(0, 14)
    } else {
        return phoneNumberString.substring(0, 14)
    }
}

export const InspectorCreate = (props) => (
    <CreateDialog {...props} fullWidth maxWidth="md" title={<h4 className="p-0 text-danger" style={{ marginLeft: '-8px' }}>Create Inspector</h4>}>
        <SimpleForm fullWidth initialValues={{ display_name: '', email: '', phone: '', notes: '', active: true }} redirect="show">
            <div className="w-100 row m-0 p-0">
                <div className="w-50">
                    <div>
                        <div>
                            <TextInput validate={required()} fullWidth className="m-0 p-0" source="display_name" label={<CustomLabelInput label="Name" />} variant="outlined" />
                        </div>
                        <div>
                            <TextInput fullWidth source="email" label={<CustomLabelInput label="Email" />} variant="outlined" />
                        </div>
                        <div>
                            <TextInput source="phone" placeholder="(000) 000-0000" validate={regex(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, 'Must be (000) 000-0000')} parse={phoneNumberFormat} label={<CustomLabelInput label="Phone"/>} fullWidth variant="outlined" resettable />
                        </div>
                    </div>
                </div>
                <div className="row w-50 m-0">
                    <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)', minHeight: '192px', marginTop: '-5px' }}>
                        <RichTextInput fullWidth source="notes" label="Notes" stripTags emptyText="Notes" toolbar={[['bold', 'italic', 'underline', 'link']]} />
                    </div>
                </div>
            </div>
        </SimpleForm>
    </CreateDialog>
);

export default InspectorCreate;
